/***
 * 系统配置group字典映射表
 * @type {{}}
 */
export const configGroupCode = {
  REGISTER: 'REGISTER',
  PORTAL: 'PORTAL',
  WITHDRAW: 'WITHDRAW',
  RECHARGE: 'RECHARGE',
  GLOBAL: 'GLOBAL'
}

/***
 * 获取指定分组的配置信息
 * @param systemConfig
 * @param groupCode
 * @returns {{config: {}}|{}}
 */
function findSystemConfigItem (systemConfig, groupCode, state) {
  if (!systemConfig || !systemConfig.length) return { config: {} }
  return (systemConfig.find(configItm => configItm.group === configGroupCode[groupCode]) || {
    config: {}
  }).config
}

/***
 * 单个配置组信息
 */
export default {
  GLOBAL_systemConfig: state => findSystemConfigItem((state.app.systemConfig[`value_${state.i18n.locale}`] || {}).data || [], configGroupCode.GLOBAL, state),
  REGISTER_systemConfig: state => findSystemConfigItem((state.app.systemConfig[`value_${state.i18n.locale}`] || {}).data || [], configGroupCode.REGISTER),
  PORTAL_systemConfig: state => findSystemConfigItem((state.app.systemConfig[`value_${state.i18n.locale}`] || {}).data || [], configGroupCode.PORTAL),
  WITHDRAW_systemConfig: state => findSystemConfigItem((state.app.systemConfig[`value_${state.i18n.locale}`] || {}).data || [], configGroupCode.WITHDRAW),
  RECHARGE_systemConfig: state => findSystemConfigItem((state.app.systemConfig[`value_${state.i18n.locale}`] || {}).data || [], configGroupCode.RECHARGE)
}



// WEBPACK FOOTER //
// ./src/utils/systemConfig.js